import axiosLib from 'axios'

export const axiosClient = axiosLib.create()
